import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, Divider, Typography } from "@mui/material";

import { getAllReviewsRoute } from "../../../../../../routers/routeUtils";

import { ButtonArrowRightIcon, ServiceOverviewTitleIcon } from "../../../../assets/icons/go-service-icons";

import ServicesReviewsList from "./ServicesReviewsList";
import { useState } from "react";

const MyServiceReviews = ({
  fullName,
  entityUserId,
  isOwn,
  isDataProfileDataLoading,
}: {
  fullName: string;
  entityUserId?: string;
  isOwn?: boolean;
  isDataProfileDataLoading?: boolean;
}) => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "goService",
  });

  const navigate = useNavigate();
  const location = useLocation();

  const { userId, entityId } = useParams();
  const id = userId || entityUserId || "";

  const persona = location.pathname.split("/")[1];
  const ALL_REVIEWS_ROUTE = getAllReviewsRoute(persona, id, entityId);

  const [hasReviews, setHasReviews] = useState(false);
  const handleSetHasReviews = (hasReviews: boolean) => setHasReviews(hasReviews);

  return (
    <Box sx={styles.container} component="section">
      <Box sx={styles.titleContainer}>
        <Typography sx={styles.title}>
          <ServiceOverviewTitleIcon />
          {t("myServiceReviews")}
        </Typography>
        {hasReviews && (
          <Button
            variant="text-md"
            endIcon={<ButtonArrowRightIcon />}
            sx={styles.seeAllReviewsButton}
            onClick={() => navigate(ALL_REVIEWS_ROUTE)}
          >
            {t("seeAllReviews")}
          </Button>
        )}
      </Box>
      <Divider sx={styles.divider} orientation="horizontal" />
      <ServicesReviewsList
        fullName={fullName}
        entityUserId={entityUserId}
        isOwn={isOwn}
        isDataProfileDataLoading={isDataProfileDataLoading}
        handleSetHasReviews={handleSetHasReviews}
      />
    </Box>
  );
};

export default MyServiceReviews;

const styles = {
  container: {
    padding: "20px 24px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  titleContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "flex-start", sm: "center" },
    gap: { xs: "8px", sm: "0" },
    justifyContent: "space-between",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  seeAllReviewsButton: {
    padding: "0",
    background: "transparent !important",
  },
  divider: { borderColor: "#EAECF0", margin: "0 -24px" },
};
